import React from 'react'
import { component_tool } from '@/tool'
let { WizDataTable, WizIcon, WizButton, WizDivider } = component_tool

export default (self, employees, other) => {
    return [
        {
            title: 'id',
            name: 'id',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: '考试名称',
            name: 'title',
            tableItem: {},
            searchItem: {},
        },
        {
            title: '开始时间',
            name: 'startDate',
            tableItem: {},
        },
        {
            title: '结束时间',
            name: 'endDate',
            tableItem: {},
        }

    ]
}